<template>
    <div>
        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <div class="panel panel-default">
                <div class="panel-body">
                    <table class="table table-condensed table-striped">
                        <thead>
                            <tr>
                                <th class="col-xs-1 text-center">
                                    <input type="checkbox" v-model="selectAll">
                                </th>

                                <th class="col-xs-4">
                                    Portal
                                </th>

                                <th class="col-xs-4">
                                    Type
                                </th>

                                <th class="col-xs-6">
                                    Price / Period
                                </th>

                                <th class="col-xs-4">
                                    Date
                                </th>

                                <th class="col-xs-4">
                                    Status
                                </th>

                                <th class="col-xs-1"></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="subscription in subscriptions.data">
                                <td class="text-center">
                                    <input type="checkbox" v-model="selected" :value="subscription">
                                </td>

                                <td>
                                    {{ subscription.portal.name }}
                                </td>

                                <td>
                                    <span v-if="subscription.subscription_type">
                                        {{ subscription.subscription_type.name }}
                                    </span>

                                    <span v-else class="label label-warning">
                                        None
                                    </span>
                                </td>

                                <td>
                                    <span v-if="getCurrentSubscriptionPeriod(subscription)">
                                        {{ getPrice(subscription) | price }} / {{ getPeriod(subscription) }} months
                                    </span>

                                    <i v-else>
                                        {{ subscription.price | price }} / {{ subscription.period }} months
                                    </i>
                                </td>

                                <td>
                                    {{ subscription.created_at | date }}
                                </td>

                                <td>
                                    <status-label :status="subscription.status"></status-label>
                                </td>

                                <td class="text-right">
                                    <div class="btn-group list-actions">
                                        <router-link
                                                :to="'subscriptions/' + subscription.id"
                                                class="btn btn-sm"
                                        >
                                            <i class="fa fa-search"></i>
                                        </router-link>

                                        <button type="button" class="btn btn-sm" @click="destroy(subscription)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>

                            <tr v-if="!subscriptions.data.length">
                                <td colspan="7" class="text-center">
                                    <i>
                                        There are no subscriptions to display.
                                    </i>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="row">
                        <div class="col-xs-6">
                            <div class="dropdown" v-if="selected.length">
                                <button
                                        class="btn btn-info btn-sm dropdown-toggle"
                                        type="button"
                                        data-toggle="dropdown"
                                >
                                    <i class="fa fa-cogs"></i> List Actions <span class="caret"></span>
                                </button>

                                <ul class="dropdown-menu">
                                    <li>
                                        <a href="#" @click.prevent="destroySelected">
                                            <i class="fa fa-trash"></i> Delete
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-xs-12">
                            <pager :pagination="subscriptions.meta" @navigate="navigate"></pager>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import modal from '@/modal'
    import moment from 'moment'
    import notify from '@/notify'
    import Load from '@/mixins/Load'
    import LoadingContainer from '@/components/Layout/LoadingContainer'
    import Pager from '@/components/Lists/Pager'
    import StatusLabel from '@/components/StatusLabel'

    export default {
        components: {LoadingContainer, Pager, StatusLabel},

        mixins: [Load],

        model: {
            prop: 'person',
            event: 'person-updated'
        },

        props: ['person'],

        data() {
            return {
                subscriptions: {},
                page: this.getQueryParam('page', 1),
                selected: [],
                selectAll: false
            }
        },

        watch: {
            selectAll(value) {
                this.selected = value ? this.subscriptions.data : []
            },

            '$route'() {
                this.load()
            }
        },

        mounted() {
            this.load()
        },

        computed: {
            queryString() {
                return '?page=' + this.page
            }
        },

        methods: {
            load() {
                this.loading = true

                http.get('/api/v1/subscriptions', {
                    person: this.person.data.id,
                    page: this.page,
                    page_size: 25
                })
                    .then(response => {
                        this.subscriptions = response.data

                        this.loading = false
                    })
            },

            destroy(subscription) {
                modal.confirm('Are you sure that you want to delete the subscription?', () => {
                    this.getDestroyPromise(subscription)
                        .then(() => {
                            notify.success('The subscription was deleted')

                            this.navigate(1)
                        })
                })
            },

            destroySelected() {
                modal.confirm('Are you sure that you want to delete the subscriptions?', () => {
                    axios.all(this.selected.map(subscription => this.getDestroyPromise(subscription)))
                        .then(() => {
                            notify.success('The subscriptions were deleted')

                            this.navigate(1)
                        })
                })
            },

            getDestroyPromise(subscription) {
                return http.delete('/api/v1/subscriptions/' + subscription.id)
            },

            navigate(page) {
                this.resetSelections()

                this.page = page

                if (this.page === parseInt(this.$route.query.page)) {
                    this.load()
                }

                this.$router.push('subscriptions' + this.queryString)
            },

            resetSelections() {
                this.selected = []

                this.selectAll = false
            },

            getQueryParam(key, defaultValue = null) {
                return typeof this.$route.query[key] !== 'undefined' ? this.$route.query[key] : defaultValue
            },

            getPrice(subscription) {
                return this.getCurrentSubscriptionPeriod(subscription).price
            },

            getPeriod(subscription) {
                return this.getCurrentSubscriptionPeriod(subscription).period
            },

            getCurrentSubscriptionPeriod(subscription) {
                return subscription.subscription_periods.find(
                    subscriptionPeriod => moment().isBefore(subscriptionPeriod.ends_at)
                )
            }
        }
    }
</script>
